export default __webpack_public_path__ + "static/media/a_b.fd65b37e.wav";